import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ContactEmailResponse {
  success: boolean;
}

@Injectable({ providedIn: 'root' })
export class EmailerService {
  private readonly http = inject(HttpClient);

  sendEmail(
    name: string,
    email: string,
    message: string,
    captchaToken: string,
  ): Observable<ContactEmailResponse> {
    return this.http.post<ContactEmailResponse>(environment.awsWafConfig.endpoint, {
      name,
      email,
      message,
      subject: `Email from ${environment.APP_NAME}`,
      captchaToken,
    });
  }
}
